import CryptoJS from 'crypto-js';

// Decrypts the AES-encrypted answer-sheet payload that backend produces via
// /v2/answer-sheet/:answerId/encrypted (matches the inline-decrypt logic in
// public/answer_sheet.html). Key is the answer ID itself.
export function decryptAnswerSheetPayload(encryptedString, answerId) {
    if (!encryptedString || !answerId) {
        throw new Error('decryptAnswerSheetPayload: missing input');
    }
    const decrypted = CryptoJS.AES.decrypt(encryptedString, String(answerId));
    const text = decrypted.toString(CryptoJS.enc.Utf8);
    if (!text) {
        throw new Error('decryptAnswerSheetPayload: empty result after decrypt');
    }
    return JSON.parse(text);
}
